// Environment configuration for CoreONE.Passport frontend

// Helper function to get default host (current behavior)
const getDefaultHost = (): string => {
  const port = window.location.port || window.location.port !== "" ? ":1234" : "";
  return window.location.protocol + '//' + window.location.hostname + port;
};

// Get build mode from environment variable, fallback to development
const BUILD_MODE = process.env.REACT_APP_BUILD_MODE || 'development';

// Environment-specific configuration
const getEnvironmentConfig = () => {
  switch (BUILD_MODE) {
    case 'production':
      return {
        CLIENT_ID: "1746460346672",
        DEBUG_MODE: false,
        CONSOLE_LOGS: false,
      };
    case 'staging':
      return {
        CLIENT_ID: "1746460346672",
        DEBUG_MODE: true,
        CONSOLE_LOGS: true,
      };
    case 'development':
    default:
      return {
        CLIENT_ID: "1746460346672",
        DEBUG_MODE: true,
        CONSOLE_LOGS: true,
      };
  }
};

const envConfig = getEnvironmentConfig();

// Environment configuration object
export const config = {
  // Environment detection
  BUILD_MODE: BUILD_MODE,
  IS_DEVELOPMENT: BUILD_MODE === 'development',
  IS_STAGING: BUILD_MODE === 'staging',
  IS_PRODUCTION: BUILD_MODE === 'production',

  // API Configuration
  API_BASE_URL: getDefaultHost(), // Always use dynamic detection

  // Environment-specific configuration
  CLIENT_ID: envConfig.CLIENT_ID,

  // Feature Flags
  FEATURES: {
    DEBUG_MODE: envConfig.DEBUG_MODE,
    CONSOLE_LOGS: envConfig.CONSOLE_LOGS,
  },

  // Constants that remain the same across environments
  BUNDLE_ID: "coreone.passport",
  CORE1_COM: "core1",
  GLOBAL_APP: "global",
  OWNER_ROLE: "global.owner",
  ADMIN_ROLE: "global.admin",
};

// Debug helper
if (config.FEATURES.CONSOLE_LOGS) {
  console.log('CoreONE.Passport Environment Config:', {
    BUILD_MODE: config.BUILD_MODE,
    CLIENT_ID: config.CLIENT_ID,
    API_BASE_URL: config.API_BASE_URL,
    DEBUG_MODE: config.FEATURES.DEBUG_MODE,
  });
} else {
  // Suppress console logs in production/release
  console.log = () => { };
  console.info = () => { };
  console.warn = () => { };
  console.error = () => { };
  console.debug = () => { };
}

export default config;